<wdx-dropdown ngbDropdown container="body" (openChange)="openChange($event)">
    <button
        class="px-2 py-1"
        type="button"
        attr.aria-label="{{
            'A11Y_ACTION_MENU_BUTTON' | translateTokenisedString
        }}"
        wdxIconButton
        [wdxButtonSize]="WdxButtonSize.Sm"
        ngbDropdownToggle
    >
        <wdx-icon iconStyle="fas" icon="ellipsis-h"></wdx-icon>
    </button>
    <wdx-dropdown-menu ngbDropdownMenu>
        @if (opened) {
            @if (
                {
                    actions: actions$ | ngrxPush,
                };
                as context
            ) {
                @if (!context?.actions) {
                    <div class="text-center p-2">
                        <wdx-spinner [small]="true"></wdx-spinner>
                    </div>
                }
                @for (action of context.actions; track $index) {
                    <button
                        type="button"
                        class="d-flex"
                        ngbDropdownItem
                        (click)="actionClicked(action, data)"
                    >
                        @if (action.icon) {
                            <wdx-icon
                                [icon]="action.icon"
                                class="me-1"
                            ></wdx-icon>
                        }
                        @if (!action.icon) {
                            <div class="m-1 ps-1"></div>
                        }
                        {{ action?.displayName?.value || action?.name }}
                    </button>
                }
            }
        }
    </wdx-dropdown-menu>
</wdx-dropdown>
